export default __webpack_public_path__ + "static/media/022-shopping basket.ead98a5f.svg";